<template>

    <div class="img-animate" id="animation_container_ninja">
        <img class="size_holder" src="/static/animations/images/holder720x800.png" />
        <canvas id="canvas_ninja" class="canvas_inner" width="720" height="800"></canvas>
        <div id="dom_overlay_container_ninja"></div>
    </div>

</template>


<script>

  let vm = {};

    export default {

        name: 'AnimatedNinja',

        data() {
            return {

            }
        },

        created() {

        },

        mounted() {

            vm = this;
            vm.init_ninja();

        },

        methods: {

            init_ninja() {
                var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;

                canvas = document.getElementById("canvas_ninja");
                anim_container = document.getElementById("animation_container_ninja");
                dom_overlay_container = document.getElementById("dom_overlay_container_ninja");
                // eslint-disable-next-line
                var comp = AdobeAn.getComposition("82D63547A8E844DBABEB86347D83DF26");
                // eslint-disable-next-line
                var ninja_lib = comp.getLibrary();
                // eslint-disable-next-line
                createjs.MotionGuidePlugin.install();
                // eslint-disable-next-line
                var loader = new createjs.LoadQueue(false);
                loader.addEventListener("fileload", function(evt){handleFileLoad(evt, comp)});
                loader.addEventListener("complete", function(evt){handleComplete(evt, comp)});
                //var ninja_lib = comp.getLibrary();
                loader.loadManifest(ninja_lib.properties.manifest);

                function handleFileLoad(evt, comp) {
                    var images = comp.getImages();
                    if (evt && (evt.item.type == "image")) { images[evt.item.id] = evt.result; }
                }
                function handleComplete(evt, comp) {
                    //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
                    var ninja_lib = comp.getLibrary();
                    var ss = comp.getSpriteSheet();
                    var queue = evt.target;
                    var ssMetadata = ninja_lib.ssMetadata;
                    for(var i = 0; i < ssMetadata.length; i++) {
                        // eslint-disable-next-line
                        ss[ssMetadata[i].name] = new createjs.SpriteSheet( {"images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames} )
                    }

                    exportRoot = new ninja_lib.ninja_trex_24_jb();
                    window.ninjaAnimation = exportRoot;

                    stage = new ninja_lib.Stage(canvas);
                    //Registers the "tick" event listener.
                    fnStartAnimation = function() {
                        stage.addChild(exportRoot);
                        // eslint-disable-next-line
                        createjs.Ticker.setFPS(ninja_lib.properties.fps);
                        // eslint-disable-next-line
                        createjs.Ticker.addEventListener("tick", stage);
                    };
                    //Code to support hidpi screens and responsive scaling.
                    function makeResponsive(isResp, respDim, isScale, scaleType) {
                        var lastW, lastH, lastS = 1;
                        window.addEventListener('resize', resizeCanvas);
                        resizeCanvas();
                        function resizeCanvas() {
                            var w = ninja_lib.properties.width, h = ninja_lib.properties.height;
                            var iw = window.innerWidth, ih = window.innerHeight;
                            var pRatio = window.devicePixelRatio || 1, xRatio = iw / w, yRatio = ih / h, sRatio = 1;
                            if (isResp) {
                                if ((respDim == 'width' && lastW == iw) || (respDim == 'height' && lastH == ih)) {
                                    sRatio = lastS;
                                } else if (!isScale) {
                                    if (iw < w || ih < h)
                                        sRatio = Math.min(xRatio, yRatio);
                                } else if (scaleType == 1) {
                                    sRatio = Math.min(xRatio, yRatio);
                                } else if (scaleType == 2) {
                                    sRatio = Math.max(xRatio, yRatio);
                                }
                            }
                            canvas.width = w * pRatio * sRatio;
                            canvas.height = h * pRatio * sRatio;
                            canvas.style.width = dom_overlay_container.style.width = anim_container.style.width =  w * sRatio + 'px';
                            canvas.style.height = anim_container.style.height = dom_overlay_container.style.height = h * sRatio + 'px';
                            stage.scaleX = pRatio * sRatio;
                            stage.scaleY = pRatio * sRatio;
                            lastW = iw;
                            lastH = ih;
                            lastS = sRatio;
                            stage.tickOnUpdate = false;
                            stage.update();
                            stage.tickOnUpdate = true;
                        }
                    }
                    makeResponsive(false, 'both', false, 1);
                    // eslint-disable-next-line
                    AdobeAn.compositionLoaded(ninja_lib.properties.id);
                    fnStartAnimation();

                    vm.$eventBus.$emit('ninja::ready');
                }
            }

        }

    }

</script>


<style lang="scss" scoped>

    #animation_container_ninja {
        width: 100% !important;
        height: auto !important;
        max-height: 800px;
        top: 0;
        left: 0;
        position: relative;
    }

    #canvas_ninja {
        position: absolute;
        display: block;
        width: 155.5555% !important;
        margin-left: -27.7777777%;
        transition: all 0.3s $easeInOutQuad;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN
            transition: all 0.3s $easeInOutQuad;
        }

        @media (min-width: 992px) { // BLUE

        }

        @media (min-width: 1200px) { // YELLOW

        }
    }
    .canvas_inner {
        width: 100% !important;
        height: 100% !important;
        top: 0;
    }

    #dom_overlay_container_ninja {
        pointer-events: none;
        overflow: hidden;
        width: inherit !important;
        height: inherit !important;
        position: absolute;
        left: 0;
        top: 0;
        display: block;
    }

    .size_holder {
        width: 100%;
        height: auto;
        position: relative;
    }

</style>
